export default __webpack_public_path__ + "static/media/Docker.d77ad029.md";